import React, { Component } from 'react';
import Cookies from 'js-cookie';


const WithConversationStorage = (WrappedComponent) => {
  return class extends Component {
    
    tabID = new Date().getTime();

    state =  {
      spinner: false,
      record: {
        messages: [],
        session: '', 
        sessionCookie: Cookies.get('IBOT_SESSION') || '',
        langCookie: Cookies.get('IDIOMA_SESION') || ''
      }
    }

    componentDidMount(){
      this.registryTab();
      this.updateConversation();
      this.setListeners();
      this.checkCookies();
      this.checkChatIsOpen();
    }

    componentDidUpdate(){
      this.checkCookies();
      this.updateOpenChatRecord(this.props.show)
    }


    setListeners= ()=>{
      window.onstorage = (e) => {
        if(e.key === 'IBOT_RECORD') this.updateConversation();
      };
      window.onunload = window.onbeforeunload = ()=>{
        //this.unregistryTab();
        this.removeLocalStorage();
      }
    }

    resetConversation = (sessionCookie, langCookie) =>{

      const record =  {
        messages: [],
        session: '', 
        sessionCookie: sessionCookie,
        langCookie: langCookie
      }
      this.setState({
        record: record
      },
      ()=>{
          window.localStorage.setItem('IBOT_RECORD', JSON.stringify(record))
          window.sessionStorage.setItem('IBOT_RECORD', JSON.stringify(record))
      }
      );
    }

    updateConversation = () =>{
      const[localData, sessionData] =  this.fetchData();

      if (localData){
        this.updateSessionStorage(localData);
        this.setState({
          record: localData
        });
      } else if(sessionData){
        this.updateLocalStorage(sessionData);
        this.updateConversation();
      }
    }

    storeData = (messages, sessionCode) =>{
      const newRecordState = this.state.record;
      newRecordState.messages = messages;
      newRecordState.session = sessionCode ||  this.state.record.session;
      this.setState({
        spinner: false,
        record: newRecordState
      },
      ()=>{
        window.localStorage.setItem('IBOT_RECORD', JSON.stringify(this.state.record))
        window.sessionStorage.setItem('IBOT_RECORD', JSON.stringify(this.state.record))
      })
    }

    removeLocalStorage = () =>{
      window.localStorage.removeItem('IBOT_RECORD');
      if (!JSON.parse(window.localStorage.getItem('IBOT_TABS_REGISTRY')).length){
        window.localStorage.removeItem('IBOT_TABS_REGISTRY');
      }
    }

    updateSessionStorage = (data)=>{
      window.sessionStorage.setItem('IBOT_RECORD', JSON.stringify(data))
    }
    updateLocalStorage = (data)=>{
      window.localStorage.setItem('IBOT_RECORD', JSON.stringify(data))
    }

    fetchData = ()=>{
      return [
        JSON.parse(window.localStorage.getItem('IBOT_RECORD')),
        JSON.parse(window.sessionStorage.getItem('IBOT_RECORD'))
      ]
    }

    showSpinner= ()=>{
      this.setState({
        spinner: true
      })
    }

    checkCookies = () =>{
      // Only master tab will check cookies
      if (this.checkTabIsMaster()){
        // if stored IBOT session data  in cookies changes it's mandatory to restart the conversation
        // because a new user session is opened or closed in the main platform

        // if stored language has changed, the conversation must restart
        const sessionCookie = Cookies.get('IBOT_SESSION') || '';
        const langCookie = Cookies.get('IDIOMA_SESION') || '';
        if (sessionCookie !== this.state.record.sessionCookie || langCookie !== this.state.record.langCookie){
          this.resetConversation(sessionCookie, langCookie);
        }
      } 
    }


    registryTab = () =>{
      // It will be necessary manage master/slave tabs to handle resetConversation event
      // Master will be the first tab in the registry
      //const tabsArray = JSON.parse(window.localStorage.getItem('IBOT_TABS_REGISTRY')) || [];
      const tabsArray = [];
      tabsArray.push(this.tabID);
      // tabs array is sorted from newest tab to oldest, so newest tab will be master
      //tabsArray.sort((a, b)=> (b - a));
      window.localStorage.setItem('IBOT_TABS_REGISTRY', JSON.stringify(tabsArray))
    }

    unregistryTab = () =>{
      const tabsArray = JSON.parse(window.localStorage.getItem('IBOT_TABS_REGISTRY'));

      const index = tabsArray.indexOf(this.tabID);
      if (index > -1) {
        tabsArray.splice(index, 1);
        window.localStorage.setItem('IBOT_TABS_REGISTRY', JSON.stringify(tabsArray));
      }
    }

    checkTabIsMaster = () => {
      // The master tab will be the one at the beggining of the array
      const tabsArray = JSON.parse(window.localStorage.getItem('IBOT_TABS_REGISTRY'));
      return tabsArray && tabsArray[0] === this.tabID;
    }

    checkSendInitialMessage =  () => {
      // @masterFactor = or it's the first time the chat is oppened and there's no registry or this tab is master
      // To prevent openning the chat in a slave tab at the fist time and not to call to the broker
      const masterFactor = !this.fetchData()[0] || this.checkTabIsMaster();
      const shoudlSend = (!this.state.record.messages.length && !this.state.spinner && masterFactor);
      return shoudlSend;
    }

    updateOpenChatRecord = (isOpen)=>{
      window.sessionStorage.setItem('IBOT_IS_OPEN', JSON.stringify(isOpen));
    }
    checkChatIsOpen = () =>{
      const isOpen = JSON.parse(window.sessionStorage.getItem('IBOT_IS_OPEN')) || false;
      if (isOpen !== this.props.show){
        this.props.closeChat();
      }
    }

    addMessages = (newMsgsArray, newSessionCode) => {
      // Adding new messages to the state
      const currentMsgs = [...this.state.record.messages, ...newMsgsArray];
      this.storeData(currentMsgs, newSessionCode) 
    }

    render(){
      const sendInitialMessage = this.checkSendInitialMessage();

      return (
        <WrappedComponent 
          storeData={this.storeData}
          spinner = {this.state.spinner}
          showSpinner = {this.showSpinner}
          sendInitialMessageFlag = {sendInitialMessage}
          messages={this.state.record.messages}
          addMessages={this.addMessages}
          connexionOptions={{lang: this.state.record.langCookie, session: this.state.record.session}}
          {...this.props} 
          />
      )
    }     
  }
}

export default WithConversationStorage;